const content = {
    chatgpt_data_upload: {
        en: {
            data_type_description: 'ChatGPT Data Upload',
            summary_no_video_html: '<p>This is the second part of the ChatGPT data task. Please upload your ChatGPT data file by following the instructions below:</p>',
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>You should have received an email notifying you that your data is ready.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Open the email and tap <b>Download data export</b>.  The data file will be downloaded to your device.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `<p>Finally, tap <b>Choose file</b> below and select the ChatGPT file from your Downloads folder.</p>`
                }
            ]
        }
    }
}

export const chatGPTDataTypes = {
    chatgpt_data_upload: {
        data_type: 'chatgpt_data_upload',
        data_type_description: 'ChatGPT Data Upload',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/chatgpt2.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: true,
        generic: {
            ...content.chatgpt_data_upload,
        }
    },
    chatgpt_ad_history: {
        data_type: 'chatgpt_ad_history',
        data_type_description: 'ChatGPT Ad History',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/chatgpt2.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: false,
        generic: {
            en: {
                // Manual-upload variant, applied by getInstructionsConfig when the
                // job's screen_capture block sets collection_mode: 'upload'. Pull
                // mode renders <ChatGPTInstructions/> and ignores this block, so it
                // can't affect the default flow. Edit these custom steps freely.
                upload_mode: {
                    instructions_type: 'standard',
                    file_source: 'default',
                    summary_no_video_html: '<p>Collect your ChatGPT ad history with the Measure Extension, then upload the file by following the steps below:</p>',
                    steps: [
                        {
                            step_type: 'numbered_step',
                            number: '1',
                            description_html: '<p>Install the <b>Measure Extension</b>.</p>'
                        },
                        {
                            step_type: 'numbered_step',
                            number: '2',
                            description_html: '<p>If you already have it installed, make sure it\'s updated to the latest version by <a href="https://chromewebstore.google.com/detail/measure-web-extension/eggbkdjkmoobojkldbkebmlkggafcnom" target="_blank" rel="noopener noreferrer">checking here</a>.</p>'
                        },
                        {
                            step_type: 'numbered_step',
                            number: '3',
                            description_html: '<p>Go to <a href="https://chatgpt.com" target="_blank" rel="noopener noreferrer">ChatGPT</a>.</p>'
                        },
                        {
                            step_type: 'numbered_step',
                            number: '4',
                            description_html: '<p>Open the Measure Extension and click "Start Collection" to begin collecting your ad history.</p>'
                        },
                        {
                            step_type: 'numbered_step',
                            number: '5',
                            description_html: '<p>Once it\'s done, click <b>Download ChatGPT Data</b> to save the file to your device.</p>'
                        },
                        {
                            step_type: 'numbered_step',
                            number: '6',
                            description_html: '<p>Return here, tap <b>Choose file</b> below to upload the file, and proceed.</p>'
                        }
                    ]
                },
            },
        },
        file_source: 'localStorage',
        instructions_type: 'component'
    },
}